import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import {
  ICallSolicitation,
  ICallSolicitationCreate,
  ICallSolicitationUpdate,
  ICallSolicitationUpdateReturn,
} from '../models/call-solicitations.models';

@Injectable({
  providedIn: 'root',
})
export class CallSolicitationsService {
  private readonly http = inject(HttpClient);

  private readonly baseUrl = '/call-solicitations';

  createCallSolicitation(
    body: ICallSolicitationCreate
  ): Observable<ICallSolicitation> {
    return this.http.post<ICallSolicitation>(this.baseUrl, body);
  }

  updateCallSolicitation(
    id: string,
    body: ICallSolicitationUpdate
  ): Observable<ICallSolicitationUpdateReturn> {
    return this.http.patch<ICallSolicitationUpdateReturn>(
      `${this.baseUrl}/${id}`,
      body
    );
  }

  getByExpertId(expertId: string): Observable<ICallSolicitation[]> {
    return this.http.get<ICallSolicitation[]>(
      `${this.baseUrl}/expert/${expertId}`
    );
  }
}
